// CreateStepLocation — wizard pane 2.
// Substrate: design/add.html lines 319-379 — `<section data-pane="2">`.
//
// Structured C1 Location writes: settlement_code, local_area,
// address_object_id, manual_address_object, building_number,
// latitude, longitude. Canonical region/settlement via shared
// LocationCanonicalFields; named-object/building via shared
// LocationStructuredAddressFields.

import LocationCanonicalFields, {
  CanonicalHierarchySummary,
} from "../../geo/widgets/LocationCanonicalFields";
import LocationStructuredAddressFields from "../../geo/widgets/LocationStructuredAddressFields";
import MapLinkCoordinatesImport from "../../geo/widgets/MapLinkCoordinatesImport";
import "../../geo/widgets/geoLocationFields.css";

function CreateStepLocation({ active, values, onChange, fieldErrors = {} }) {
  const setField = (key, value) => onChange({ ...values, [key]: value });

  const handleCoordinatesImported = ({ latitude, longitude }) => {
    onChange({ ...values, latitude, longitude });
  };

  return (
    <section
      className={active ? "ap-pane is-active" : "ap-pane"}
      data-pane="2"
      aria-labelledby="ap-pane-2"
      hidden={!active}
    >
      <header className="ap-pane__head">
        <h2 id="ap-pane-2">
          <i className="fa-solid fa-location-dot" aria-hidden="true" />
          Локація
        </h2>
        <p>
          Локація <strong>обов'язкова для активації</strong> оголошення
          (статус ACTIVE). Координати ставлять пін на карті.
        </p>
      </header>

      <div className="ap-row ap-row--2">
        <div className="ap-field">
          <div
            className="geo-country-context"
            data-testid="geo-country-context"
          >
            <span className="geo-country-context__label" id="loc-country-label">
              Країна
            </span>
            <p
              className="geo-country-context__value"
              aria-labelledby="loc-country-label"
            >
              Україна
            </p>
          </div>
        </div>
      </div>

      <LocationCanonicalFields
        values={values}
        onChange={onChange}
        fieldErrors={fieldErrors}
        idPrefix="loc"
      />

      <LocationStructuredAddressFields
        values={values}
        onChange={onChange}
        fieldErrors={fieldErrors}
        idPrefix="loc"
      />

      {values.selectedSettlement ? (
        <CanonicalHierarchySummary
          unit={values.selectedSettlement}
          idPrefix="loc"
        />
      ) : null}

      <MapLinkCoordinatesImport
        idPrefix="loc"
        onCoordinatesImported={handleCoordinatesImported}
      />

      <div className="ap-row ap-row--2">
        <div className="ap-field">
          <label htmlFor="loc-lat">Широта</label>
          <input
            id="loc-lat"
            name="latitude"
            type="number"
            step="0.000001"
            className="form-control"
            placeholder="48.922737"
            value={values.latitude ?? ""}
            onChange={(e) => setField("latitude", e.target.value)}
          />
          {fieldErrors.latitude ? (
            <small className="form-hint text-danger">
              {fieldErrors.latitude}
            </small>
          ) : null}
        </div>
        <div className="ap-field">
          <label htmlFor="loc-lng">Довгота</label>
          <input
            id="loc-lng"
            name="longitude"
            type="number"
            step="0.000001"
            className="form-control"
            placeholder="24.710395"
            value={values.longitude ?? ""}
            onChange={(e) => setField("longitude", e.target.value)}
          />
          {fieldErrors.longitude ? (
            <small className="form-hint text-danger">
              {fieldErrors.longitude}
            </small>
          ) : null}
        </div>
      </div>

      <p className="ap-helper">
        <i className="fa-solid fa-circle-info" aria-hidden="true" />
        Не знаєте координати?{" "}
        <a
          href="https://www.openstreetmap.org/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Знайти на OpenStreetMap
          <i className="fa-solid fa-up-right-from-square" aria-hidden="true" />
        </a>
      </p>
    </section>
  );
}

export default CreateStepLocation;
